import React from "react"
import { NavLink } from "react-router-dom"
import LogoImage from "assets/images/Logo.png"
import styles from "./AppLogo.module.scss"


export const AppLogo = () => {
    return (
        <NavLink className={styles.logo} to="/">
            <img src={LogoImage} alt="Logo"/>
        </NavLink>
    )
}